import React from 'react';
import SectionContainer from './SectionContainer';
import MetricDisplay from './MetricDisplay';
import TrendChart from './TrendChart';

function RatesSection({ data, nationalAvg, utilityData, selectedYear }) {
  if (!data) {
    return (
      <SectionContainer icon="&#x1F4B0;" title="Rates & Affordability">
        <p className="text-sm text-gray-400">No rate data available</p>
      </SectionContainer>
    );
  }

  return (
    <SectionContainer icon="&#x1F4B0;" title="Rates & Affordability">
      <div className="space-y-1 divide-y divide-gray-100">
        <MetricDisplay
          label="Residential Rate"
          value={data.residential_cents_kwh}
          unit="&#162;/kWh"
          nationalAvg={nationalAvg?.residential_cents_kwh}
          lowerIsBetter={true}
          precision={2}
          showChange={true}
          changeValue={data.residential_change_1yr_pct}
        />

        <MetricDisplay
          label="Commercial Rate"
          value={data.commercial_cents_kwh}
          unit="&#162;/kWh"
          nationalAvg={nationalAvg?.commercial_cents_kwh}
          lowerIsBetter={true}
          precision={2}
        />

        <MetricDisplay
          label="Industrial Rate"
          value={data.industrial_cents_kwh}
          unit="&#162;/kWh"
          nationalAvg={nationalAvg?.industrial_cents_kwh}
          lowerIsBetter={true}
          precision={2}
        />
      </div>

      {/* Rate change indicators */}
      {(data.residential_change_1yr_pct || data.residential_change_5yr_pct) && (
        <div className="mt-3 pt-3 border-t border-gray-100">
          <h4 className="text-xs font-medium text-gray-500 uppercase mb-2">Rate Changes</h4>
          <div className="grid grid-cols-2 gap-2">
            {data.residential_change_1yr_pct !== undefined && (
              <div className="text-sm">
                <span className="text-gray-500">1-Year: </span>
                <span className={data.residential_change_1yr_pct > 0 ? 'text-red-600' : 'text-green-600'}>
                  {data.residential_change_1yr_pct > 0 ? '+' : ''}{data.residential_change_1yr_pct}%
                </span>
              </div>
            )}
            {data.residential_change_5yr_pct !== undefined && (
              <div className="text-sm">
                <span className="text-gray-500">5-Year: </span>
                <span className={data.residential_change_5yr_pct > 0 ? 'text-red-600' : 'text-green-600'}>
                  {data.residential_change_5yr_pct > 0 ? '+' : ''}{data.residential_change_5yr_pct}%
                </span>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Trend chart */}
      <div className="mt-3 pt-3 border-t border-gray-100">
        <h4 className="text-xs font-medium text-gray-500 uppercase">Residential Rate Trend</h4>
        <TrendChart
          utilityData={utilityData}
          metricPath="rates.residential_cents_kwh"
          selectedYear={selectedYear}
          label="Residential Rate"
          unit="&#162;/kWh"
          color="#2563eb"
          lowerIsBetter={true}
        />
      </div>

      {/* Data source */}
      <div className="text-xs text-gray-400 mt-3 pt-2 border-t border-gray-100">
        Source: EIA-861 Annual Electric Power Industry Report
      </div>
    </SectionContainer>
  );
}

export default RatesSection;
